/**
 * 是否是微前端，目前只处理 iframe 嵌套，后续引入微前端框架再扩展
 * @returns
 */
export function isMicroApp() {
    return window.parent !== window;
}
